import type { EngineeringNote } from '../../types/calc';

// MIRROR of backend/src/modules/calculators/ss-tank/engineering-notes.ts
// Both files must stay in sync — see scripts/check-engineering-notes-parity.ts.
// Wording is contract-locked; do not edit without bumping the backend snapshot
// version and writing a migration.

export const ENGINEERING_NOTES: ReadonlyArray<EngineeringNote> = [
  {
    parameter: 'Manufacturing Process',
    sunstellar:
      'High Frequency Seam Welding — minimal Heat Affected Zones, near-seamless finish that resists corrosion at the joint.',
    industry:
      'Manual Argon (TIG) or resistance welding — wide HAZ along welds, the first place corrosion and leaks begin.',
  },
  {
    parameter: 'Connections & Fittings',
    sunstellar:
      'Weldless Bulkhead Fittings — sealed mechanically, no welding at inlet, outlet, or overflow.',
    industry:
      'Welded fittings — stress corrosion cracking causes slow leaks at connections after a few years of use.',
  },
  {
    parameter: 'Inner Tank Weld Protection',
    sunstellar:
      'Food-Grade Ceramic Coating on weld zones — non-toxic, certified safe, preserves water purity.',
    industry:
      'Industrial paints or anti-rust chemicals — release harmful substances into stored drinking water.',
  },
  {
    parameter: 'Structural Reinforcement',
    sunstellar:
      'Specialised inner-tank corrugation up to 1.6 mm thickness — ribbed strength, no bulging under pressure.',
    industry:
      'Cannot effectively reinforce tanks — either over-spec thickness (cost) or risk deformation (safety).',
  },
  {
    parameter: 'PUF Insulation',
    sunstellar:
      'High-density 45–48 kg/m³ PUF from Dow Chemicals or equivalent — superior thermal performance.',
    industry:
      'Low-density, normal-grade PUF — poor insulation in peak summers and winters; degrades over time.',
  },
  {
    parameter: 'Quality Standards',
    sunstellar:
      'Kaizen + 5S + manufacturing ERP system — every tank traceable, consistent quality every batch.',
    industry:
      'Non-compliant work areas, unstructured processes — variable product quality batch to batch.',
  },
  {
    parameter: 'Warranty & Service',
    sunstellar:
      '10-year product warranty + on-site service across our service areas. Complete peace of mind.',
    industry:
      "Shorter warranty (typically 1–5 years), limited on-site service — repairs often the customer's problem.",
  },
  {
    parameter: 'Manufacturing Philosophy',
    sunstellar:
      'Minimum-welding design — bottom frame is clamped (not welded) to the tank body, fewer failure points.',
    industry:
      'Heavy welding throughout — bottom frame, fittings, and connections all welded; many potential leak points.',
  },
];
